import React, { useState, useMemo, useEffect } from "react";
import moment from "moment";
import styles from "./styles.module.scss";
import PolicyItem from "src/components/policyItem";
import { UIText } from "src/components/uIKit";
import { useAppSelector, useAppDispatch } from "src/hooks/useRedux";
import { useOutletContext } from "react-router-dom";
import { ChoosePolicyProps, CountryOfDestinationDto, PolicyItemType } from "src/utils/types";
import { setSelectedPolicy, setTravelPolicyNumber } from "src/redux/slices/appSlice/AppSlice";
import ScreenReaderText from "src/components/accessibilityKit/screenReaderText/ScreenReaderText";
import { useLogAnalytics } from "src/hooks/useLogAnalytics";



const ChoosePolicy: React.FC = () => {
  const dispatch = useAppDispatch();
  useLogAnalytics({ login_choose_policy: true });
  const [selectedPolicyIndex, setSelectedPolicyIndex] = useState<number | null>(null);
  const { setChoosenPolicyItem, checkboxChange } = useOutletContext<ChoosePolicyProps>();
  const { strings, fXEligibilityData } = useAppSelector((state) => state.app);

  const formatPolicyData = (policyDetails: any[]): PolicyItemType[] => {
    return policyDetails.map((policy, index) => ({
      index,
      passengers: policy.leadDetailsDtoField.numberOfPassangersField.toString(),
      dates: `${moment(policy.policyDtoField.policyEndDateField).format(
        "DD/MM"
      )} - ${moment(policy.policyDtoField.policyStartDateField).format(
        "DD/MM"
      )}`,
      destination: policy.countryOfDestinationDtoField
        .map((country: CountryOfDestinationDto) => country.countryField)
        .join(", "),
    }));
  };
  
  const policies = useMemo(() => 
    formatPolicyData(fXEligibilityData.policyDetails),
    [fXEligibilityData.policyDetails]
  );

  const handleCheckboxChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    // Store the current scroll position
    const scrollPosition = window.scrollY;
    
    if (selectedPolicyIndex === index) {
      setSelectedPolicyIndex(null);
      setChoosenPolicyItem(null);
      checkboxChange(event);
    } else {
      setSelectedPolicyIndex(index);
      dispatch(setSelectedPolicy(fXEligibilityData.policyDetails[index]));
      dispatch(setTravelPolicyNumber(fXEligibilityData.policyDetails[index].policyDtoField.travelPolicyNumberField.toString()));
      setChoosenPolicyItem(policies[index]);
      checkboxChange(event);
    }
    
    // Restore scroll position after state updates
    setTimeout(() => {
      window.scrollTo(0, scrollPosition);
    }, 0);
  };

  useEffect(() => {
    // Only focus on initial render, not after checkbox changes
    const timeout = setTimeout(() => {
      document.getElementById(`ui-radio-btn-policy-${policies[0]?.index}`)?.focus();
    }, 2000);

    return () => clearTimeout(timeout);
  }, []); // Empty dependency array ensures this only runs once after initial render

  return (
    <div className={styles.container}>
      <ScreenReaderText text={strings.acc_t_choose_policy_sub_title} announnceDelay={2100}/>
   

      <UIText
        text={strings.t_choose_policy_sub_title}
        size={18}
        weight={600}
        style={styles.cardSubTitle}
        announce={true}
        politeness="assertive"
      />
      <br />
      <br />
      {policies.map((item) => (
        <PolicyItem
          key={`choose-policy-item-${item.index}`}
          passengers={item.passengers}
          dates={item.dates}
          destination={item.destination}
          index={item.index}
          isChecked={selectedPolicyIndex === item.index}
          onCheckboxChange={handleCheckboxChange}
        />
      ))}
    </div>
  );
};

export default ChoosePolicy;
